import {
  Box,
  Modal,
} from "@mui/material"
import { useState } from "react"
import { Button } from "react-bootstrap"
import { toast } from "react-toastify"
import { post } from "../../../util/Axios"
import { Context, DBServer } from "../../../types/types"
import DBServerPicker from "../../Pickers/DBServerPicker"

export interface TenantDBMoveModalProps {
  selectedRows: any[]
  open: boolean
  cancel: Function
  context: Context
  onSuccess: Function
}

function TenantDBMoveModal(props: TenantDBMoveModalProps) {
  const [selectedServer, setSelectedServer] = useState<DBServer | undefined>(
    undefined
  )

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    minHeight: "20%",
    maxHeight: "75%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    overflow: "hidden",
    p: 4,
  }
  
  const moveTenants = () => {
    if (!selectedServer) return

    const selectedTenants = props.selectedRows
    const tenantIds = selectedTenants.map((tenant) => tenant.id)
    post(`/contexts/${props.context?.id}/crud/mandantendbmove`, {
      tenant_ids: tenantIds,
      db_server_id: selectedServer.id
    })
      .then((response) => {
        if (response.status === 200) {
          toast.success("Started Tenant DBMove successfully!")
        } else {
          toast.error(
            `Error moving tenants ${response.status}: ${response.data}`
          )
        }
      })
      .catch((error) => {
        toast.error(
          `Error moving tenants ${error.response.status}: ${error.response.data}`
        )
      })
    props.onSuccess()
  }

  return (
    <Modal
      open={props.open}
      onClose={() => {
        props.cancel()
      }}
    >
      <Box sx={style}>
        <div style={{display: "flex", gap: "10px", flexDirection: "column"}}>
          <span>
            You are about to move {props.selectedRows.length} Tenant(s)
            <br />
            Below you can select which DB Server you want to move the Tenants to and how many tenants it currently already holds.
          </span>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <DBServerPicker
              context={props.context}
              label="DB Server"
              server={selectedServer}
              setServer={setSelectedServer}
            />
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button variant="secondary" onClick={() => props.cancel()}>
              Cancel
            </Button>
            <Button onClick={() => moveTenants()}>Move Tenants</Button>
          </div>
        </div>
      </Box>
    </Modal>
  )
}

export default TenantDBMoveModal
